import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0154baca"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "progress__area cms-card-block mg-t--15"
};
const _hoisted_2 = {
  class: "cms-card-block"
};
import ActionHeader from '@/views/common/ActionHeader/index.vue';
import ProgressLine from '@/views/common/ProgressLine/index.vue';
import BasicInfo from './BasicInfo/index.vue';
import RelationInfo from './RelationInfo/index.vue';
import UploadImg from './UploadImg/index.vue';
import AddOrEdit from '../SeriesFilm/AddOrEdit/index.vue';
import { computed, ref, provide, onMounted } from 'vue';
import { elMessage } from '@/utils';
import { useVodLanguages } from '@/utils/cacheData';
import { debounce, scrollIntoView } from '@/utils/tools';
import { useCommon } from '@/store/useCommon';
import { addProgramApi, editProgramApi, getProgramInfoApi } from '@/api/vodNew';
export default /*#__PURE__*/_defineComponent({
  __name: 'edit',
  props: {
    detailInfo: {
      type: Object,
      default: () => {}
    },
    addType: {
      type: String,
      default: 'film'
    },
    mediaParams: {
      type: Object,
      default: null
    }
  },
  emits: ['on-cancel', 'update-list'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const basicInfoRef = ref();
    const mediaInfoRef = ref();
    const relationInfoRef = ref();
    const uploadImgRef = ref();
    const titleComputed = computed(() => props.detailInfo.id ? '编辑影片' : '新增影片'); // 标题配置

    const headerConfig = reactive({
      title: titleComputed,
      btnList: [{
        label: '返回',
        func: () => {
          emit('on-cancel');
          emit('update-list');
        }
      }]
    }); // 进度条配置

    const progressData = reactive({
      active: 0,
      data: [{
        title: '基础信息',
        key: 0
      }, // { title: '媒体内容', key: 1 },
      {
        title: '关联分类',
        key: 1
      }, {
        title: '上传图片',
        key: 2
      }],
      loading: false
    });
    const data = ref({
      programType: props.detailInfo.programType,
      name: '',
      detailList: [],
      mediaList: {
        mediaList: []
      },
      tvSeasonMediaList: [],
      categoryIdList: [],
      posterList: [],
      adult: 'no',
      id: '',
      paymentForm: 'free',
      //subtitleList: [],
      videoSeriesIdList: [],
      sequence: '',
      cloudDiskIdList: []
    }); // 获取影片详情

    const getProgramInfoById = async () => {
      try {
        progressData.loading = true;
        let params = {
          programId: props.detailInfo.id,
          programType: props.detailInfo.programType,
          infoType: 1
        };
        const res = await getProgramInfoApi(params);

        if (res.code == '0') {
          data.value = res.data; //data.value.programType = res.data.mediaList ? 'movie' : 'tv_series'  

          if (res.data.detailList) {
            res.data.detailList.forEach(item => {
              //item.ifChange = false;
              item.isShowTable = false;
              item.length = item.length ? item.length : '';
              item.genreList = item.genreList ? item.genreList : [];
              item.year = item.year ? item.year : '';
              item.videoId = item.trailerVideoIdList ? item.trailerVideoIdList.join(',') : '';
              item.rating = item.rating ? item.rating : '';
              item.imdbId = item.sourceId ? item.sourceId : '';
              item.infoId = item.sourceName; //信息源类型 TMDB/IMDB/ARAB
            });
          }

          if (res.data.posterList) {
            // 复显第四步的数据, type:添加方式 默认1， 海报类型posterType
            res.data.posterList.forEach(item => {
              item.url = item.imageUrl ? item.imageUrl : '';
              item.posterType = item.type ? item.type : 'common';
              item.type = 0;
            });
          }
        }
      } catch (error) {}

      progressData.loading = false;
    };

    provide('finishData', data);
    provide('mediaParams', computed(() => {
      return props.mediaParams;
    }));
    const languageOptions = ref([]); // 获取所有语言

    const getAllLanguages = async () => {
      const res = await useVodLanguages();
      languageOptions.value = res;
    };

    provide('languageOptions', languageOptions); // 下一步

    const handleNext = debounce(async () => {
      validatorCurrentActiveDataFn('next', progressData.active + 1);
    }, 300); // 上一步

    const handleLast = debounce(async () => {
      validatorCurrentActiveDataFn('last', progressData.active - 1);
    }, 300); // 取消

    const handleCancel = () => {
      emit('on-cancel');
      emit('update-list');
    }; // 完成


    const handleOk = debounce(async () => {
      // 首先校验步骤四
      Promise.all([uploadImgRef.value.imageItemRef.validate(), uploadImgRef.value.androidImageItemRef.validate(), uploadImgRef.value.horizonImageItemRef.validate()]).then(async valid => {
        if (valid) {
          console.log('校验成功了嘛', data.value);
          progressData.loading = true; // 通用海报、安卓海报、横版海报

          let allPictureList = [...uploadImgRef.value.data.pictureList, ...uploadImgRef.value.data.androidPictureList, ...uploadImgRef.value.data.horizonPictureList];
          data.value.posterList = allPictureList.map(item => ({
            base64Image: item.base64Image,
            language: item.language,
            // name: item.name,
            type: item.posterType,
            url: item.url,
            id: item.id ? item.id : '' //posterType: item.posterType

          }));
          const params = { ...JSON.parse(JSON.stringify(data.value)),
            cid: props.addType == 'media' ? useCommon().userData.cid[0] || 0 : sessionStorage.getItem('currentCid'),
            cpspId: props.addType == 'media' ? useCommon().userData.cpspid || 0 : sessionStorage.getItem('currentCpspid'),
            // 修改最外层的sourceName，sourceId
            sourceId: data.value.detailList[0]?.infoId,
            sourceName: data.value.detailList[0]?.imdbId
          };
          params.name = params.name.trim();
          params.detailList.forEach(item => {
            item.name = item.name.trim(); //item.imdbId = item.imdbId.trim();

            item.sourceId = item.imdbId;
            item.trailerVideoIdList = item.videoId ? String(item.videoId).split(',') : [];
            item.sourceName = item.infoId; //信息源类型 TMDB/IMDB/ARAB

            delete item.infoId;
            delete item.mediaName;
            delete item.adult;
            delete item.isShowTable;
          });

          if (props.detailInfo.id) {
            try {
              delete params.cpspid;
              console.log('提交编辑数据', params);
              const res = await editProgramApi(params);

              if (res.code == '0') {
                elMessage('success', '修改成功');
                emit('on-cancel');
                emit('update-list');
              }
            } catch (error) {
              console.log('288err', error);
            }

            progressData.loading = false;
          } else {
            try {
              console.log('提交新增的数据', params);
              const res = await addProgramApi(params);

              if (res.code == '0') {
                elMessage('success', '新增成功');
                emit('on-cancel');
                emit('update-list');
              }
            } catch (error) {
              console.log('317err', error);
            }

            progressData.loading = false;
          }
        }
      }).catch(err => {
        scrollIntoView();
      });
    }, 300); // 步骤条item点击事件

    const onStepClick = debounce(stepIndex => {
      validatorCurrentActiveDataFn('step', stepIndex);
    }, 300); // 校验当前步骤数据/保存数据

    const validatorCurrentActiveDataFn = (type, stepIndex) => {
      if (progressData.active === 0) {
        // 当前为步骤一, 如果stepIndex等于步骤二 或者最大步骤数大于或者等于stepIndex, 则校验进行跳步或下一步
        if (stepIndex == progressData.active + 1 || maxStepIndex.value >= stepIndex) {
          Promise.all([basicInfoRef.value.TopFormRef.validate(), basicInfoRef.value.FormRef.validate()]).then(valid => {
            // 注意： 第一步基础信息如果加了选项，要在这里双向绑定，给data.value
            data.value.programType = basicInfoRef.value.topformConfig.formData.programType;
            data.value.name = basicInfoRef.value.topformConfig.formData.name;
            data.value.adult = basicInfoRef.value.topformConfig.formData.adult;
            data.value.paymentForm = basicInfoRef.value.topformConfig.formData.paymentForm;
            data.value.videoSeriesIdList = basicInfoRef.value.topformConfig.formData.videoSeriesIdList;
            data.value.sequence = basicInfoRef.value.topformConfig.formData.sequence;
            data.value.detailList = basicInfoRef.value.formConfig.formData;
            data.value.cloudDiskIdList = basicInfoRef.value.topformConfig.formData.cloudDiskIdList;
            progressData.active = stepIndex;
          }).catch(err => {
            let errFormItemArr = [];

            for (let k in err) {
              if (k.includes('.')) {
                errFormItemArr.includes(k.split('.')[0]) ? '' : errFormItemArr.push(k.split('.')[0]);
              }
            }

            basicInfoRef.value.changeTableDisplay(errFormItemArr);
            scrollIntoView();
          });
        }
      } else if (progressData.active === 1) {
        // 当前为步骤三, 无需校验, 进行数据保存即可
        data.value.categoryIdList = relationInfoRef.value.dataInfo.selectList.map(item => item.id);
        progressData.active = stepIndex;
      } else if (progressData.active === 2) {
        // 当前为步骤四, 进行跳步无需校验, 进行数据保存即可
        data.value.posterList = uploadImgRef.value.data.pictureList.map(item => ({
          base64Image: item.base64Image,
          language: item.language,
          name: item.name,
          type: item.type,
          url: item.url,
          file: item.file,
          id: item.id ? item.id : '',
          posterType: item.posterType
        }));
        progressData.active = stepIndex;
      }
    };

    const addOrEdit = reactive({
      visible: false
    });

    const toSeriesFilm = () => {
      addOrEdit.visible = true;
    };

    onMounted(() => {
      getAllLanguages(); // 有id 是编辑进来

      if (props.detailInfo.id) {
        maxStepIndex.value = 3;
        getProgramInfoById();
      } // 类型为 media 从媒资管理进来


      if (props.addType == 'media') {
        data.value.name = props.mediaParams.name;
        data.value.programType = props.mediaParams.programType;
      }
    }); // 记录当前最大步骤数

    const maxStepIndex = ref(0);
    watch(() => progressData.active, val => {
      if (val > maxStepIndex.value) {
        maxStepIndex.value = val;
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", null, [_withDirectives(_createElementVNode("div", null, [_createVNode(ActionHeader, {
        config: headerConfig
      }, null, 8, ["config"]), _createElementVNode("div", _hoisted_1, [_createVNode(ProgressLine, {
        modelValue: progressData.active,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => progressData.active = $event),
        onOnStepClick: _unref(onStepClick),
        progressData: progressData.data
      }, null, 8, ["modelValue", "onOnStepClick", "progressData"])]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [progressData.active === 0 ? (_openBlock(), _createBlock(BasicInfo, {
        key: 0,
        ref_key: "basicInfoRef",
        ref: basicInfoRef,
        onToSeriesFilm: toSeriesFilm
      }, null, 512)) : _createCommentVNode("", true), progressData.active === 1 ? (_openBlock(), _createBlock(RelationInfo, {
        key: 1,
        ref_key: "relationInfoRef",
        ref: relationInfoRef,
        programType: data.value.programType
      }, null, 8, ["programType"])) : _createCommentVNode("", true), progressData.active === 2 ? (_openBlock(), _createBlock(UploadImg, {
        key: 2,
        ref_key: "uploadImgRef",
        ref: uploadImgRef
      }, null, 512)) : _createCommentVNode("", true)]), _createElementVNode("div", {
        class: _normalizeClass(["btn-operate", progressData.active === 1 ? 'compatibility' : ''])
      }, [progressData.active === 0 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: "btn-cancel cms-op-btn-non-focus",
        onClick: handleCancel
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('取消')), 1)]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        class: "btn-cancel cms-op-btn-non-focus",
        onClick: _unref(handleLast)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('上一步')), 1)]),
        _: 1
      }, 8, ["onClick"])), progressData.active === 2 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 2,
        class: "btn-confirm",
        onClick: _unref(handleOk)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('确定')), 1)]),
        _: 1
      }, 8, ["onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
        key: 3,
        class: "btn-confirm cms-op-btn-main",
        onClick: _unref(handleNext)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('下一步')), 1)]),
        _: 1
      }, 8, ["onClick"]))], 2)])], 512), [[_vShow, !addOrEdit.visible]]), _createVNode(AddOrEdit, {
        modelValue: addOrEdit.visible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => addOrEdit.visible = $event),
        "detail-info": {
          id: ''
        }
      }, null, 8, ["modelValue"])])), [[_directive_loading, progressData.loading]]);
    };
  }

});